import React, { ReactNode } from 'react';
import { Badge as HeroBadge } from '@heroui/react';

export interface BadgeProps {
  children: ReactNode;
  variant?: 'solid' | 'faded' | 'flat' | 'shadow';
  color?: 'default' | 'primary' | 'danger' | 'success' | 'warning';
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  isInvisible?: boolean;
  placement?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
  content: string | number | ReactNode;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'solid',
  color = 'primary',
  className = '',
  size = 'lg',
  isInvisible = false,
  placement = 'top-right',
  content,
}) => {
  return (
    <div className="relative inline-block">
      <HeroBadge
        variant={variant}
        color={color}
        className={className}
        size={size}
        isInvisible={isInvisible}
        placement={placement}
        content={content}
      >
        {children}
      </HeroBadge>
    </div>
  );
};

export default Badge;
